import RMButton from 'components/customComponents/Controls/RMButton';
import React from 'react';
import { MergeStockSectionProps } from '../IngredientConstants';
import { useGetInputFields } from './MergeStockUtils';
import { SingleInputField } from './SingleInputField';
import { SplittedInputField } from './SplittedInputFields';
import { FmlxButton } from 'fmlx-common-ui';

export const MergeStockSection = (props: MergeStockSectionProps) => {
  const {
    heading,
    currentMergeStockType,
    buttonText,
    onClickButton,
    onClickAdd,
    onClickDelete,
    showButtons,
    tempStock,
    stock,
    setTempStock,
    liquidClasses,
  } = props;

  const inputFields = useGetInputFields({
    stock: stock,
    currentMergeStockType: currentMergeStockType,
    liquidClasses: liquidClasses,
    onClickAdd: onClickAdd,
    onClickDelete: onClickDelete,
    setTempStock: setTempStock,
    showButtons: showButtons,
    tempStock: tempStock,
  });
  if (!inputFields) {
    return <></>;
  }
  return (
    <>
      <div id='mergestocksection-container' className="flex flex-direction-row justify-between">
        <span id={`mergestocksection-${heading}`}>{heading}</span>
        <RMButton
          id='mergestocksection-button'
          onClick={() => onClickButton(currentMergeStockType)}
          label={buttonText}
          type={FmlxButton.Type.POSITIVE}
        ></RMButton>
      </div>
      <hr id="mergestocksection-divider" className="hr-line" />
      <SplittedInputField id="mergestocksection-section1" fields={inputFields.section1}></SplittedInputField>
      <SingleInputField id="mergestocksection-section2" fields={inputFields.section2}></SingleInputField>
      <SplittedInputField id="mergestocksection-section3" fields={inputFields.section3}></SplittedInputField>
      <SingleInputField id="mergestocksection-section4" fields={inputFields.section4}></SingleInputField>
    </>
  );
};
